import React from 'react';
import './Manage.css';

export const Manage: React.FC<{}> = () => {
  return <p className="manage">Nothing here</p>;
};
